/**
 * Template function. It's loosely based on underscore.js template function.
 *
 *     @example
 *
 *      var body = document.getElementsByTagName('body')[0];
 *
 *      // Instance Template Class
 *      const template = new Template(
 *        '<span><%=name%></span>',
 *        { name: 'Tom' },
 *        'name'
 *      );
 *
 *     //  Build template
 *     body.innerHTML = template.build();
 *
 * @param {String} str  Template string.
 * @param {Object} data Data passed to template.
 * @param {String} argName
 */

export default class Template {
  constructor(str, data, argName = 'o') {
    this.str = str;
    this.data = data;
    this.argName = argName;
  }

  build() {
    const
      self = this,
      evaluate    = /<%([\s\S]+?)%>/g,
      interpolate = /<%=([\s\S]+?)%>/g,
      escape      = /<%-([\s\S]+?)%>/g,
      // if you don't want to define an interpolation, evaluation or escaping regex,
      // we need one that is guaranteed not to match.
      noMatch = /.^/;

    const tmpl =
      'var __p=[],print=(...args)=>__p.push.apply(__p,args),get=(...args)=>solodev.prop.get.apply(null, typeof args[0]==="string"?['+self.argName+'].concat(args):args);' +
      '__p.push(\'' +
      self.str.replace(/\\/g, '\\\\')
        .replace(/'/g, "\\'")
        .replace(escape || noMatch, function(match, code) {
          return "',__encodeHtml(" + self.unescape(code) + "),'";
        })
        .replace(interpolate || noMatch, function(match, code) {
          return "'," + self.unescape(code) + ",'";
        })
        .replace(evaluate || noMatch, function(match, code) {
          return "');" + self.unescape(code).replace(/[\r\n\t]/g, ' ') + ";__p.push('";
        })
        .replace(/\r/g, '\\r')
        .replace(/\n/g, '\\n')
        .replace(/\t/g, '\\t') + "');return __p.join('');";

    const func = new Function(self.argName, '__encodeHtml', tmpl);

    if (this.data) {
      return func(this.data, this.encodeHtmlEntities);
    }

    return function(data) {
      return func.call(this, data, this.encodeHtmlEntities);
    };
  }

  // Within an interpolation, evaluation, or escaping, remove HTML escaping
  // that had been previously added.
  unescape(code) {
    return code.replace(/\\\\/g, '\\').replace(/\\'/g, "'");
  }

  /**
 * Escape a string for HTML interpolation.
 *
 * @param {String} string
 * @return {String}
 */
  encodeHtmlEntities(string) {
    return (''+string).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g,'&#x2F;');
  }
}
